import React from "react";
import PropTypes from 'prop-types';
import { default as SortableTree, toggleExpandedForAll, walk } from "react-sortable-tree";
import FileExplorerTheme from 'react-sortable-tree-theme-full-node-drag';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';

import {
    withStyles,
    CircularProgress,
    TextField,
    FormControlLabel,
    Checkbox,
    FormLabel,
    IconButton,
    Drawer,
    Tooltip,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Switch
} from '@material-ui/core/';

import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import FlagIcon from '@material-ui/icons/Flag';
import TranslateIcon from '@material-ui/icons/Translate';
import RefreshIcon from '@material-ui/icons/Refresh';
import TestIcon from '@material-ui/icons/QuestionAnswer';
import AddIcon from '@material-ui/icons/Add';
import NormalizeIcon from '@material-ui/icons/Sort'
import CodeIcon from '@material-ui/icons/Code';
import SaveIcon from '@material-ui/icons/Save';

import {
    isArrayValid
} from '../utils/Utils';

import {
    deleteQuestionErrors
} from '@apricityhealth/web-common-lib/utils/Services';

import JsonDialog from '../dialogs/JsonDialog';
import EditQuestionDialog from '../dialogs/EditQuestionDialog';
import SaveAllQuestionsDialog from '../dialogs/SaveAllQuestionsDialog'
import DeleteQuestionDialog from '../dialogs/DeleteQuestionDialog';
import AdHocTranslationDialog from '../dialogs/AdHocTranslationDialog';
import SelectLanguage from '@apricityhealth/web-common-lib/components/SelectLanguage';
import { ImportExport } from '@apricityhealth/web-common-lib/components/ImportExport';
import Plan from '@apricityhealth/web-common-lib/components/Plan';

import ConversationTestView from "./ConversationTestView";
//import QuestionErrorsView from "./QuestionErrorsView";
import PubSub from 'pubsub-js'
import getErrorMessage from "@apricityhealth/web-common-lib/utils/getErrorMessage";
import EditableNote from '../components/EditableNote'
import '../styles/questions.css';

const maxDepth = 3;

function getText(texts, textId, language = 'en-us') {
    if (texts[language]) {
        if (texts[language][textId]) {
            return texts[language][textId]
        } else {
            //console.error(`Failed to find textId [${textId}]`, texts[language] );
        }
    }
    else {
        //console.error(`Failed to find language [${language}]`)
    }
    return null;
}

function filterQuestion(filter, question, texts, language) {
    if (filter === "" || filter === "*") return true;
    if (question) {
        let translation = getText(texts, question.questionId, language);
        if (translation && translation.text) {
            if (translation.text.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
                return true;
        }

        if (question.questionId && question.questionId.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
            return true;
        if (isArrayValid(question.answers)) {
            for (let i = 0; i < question.answers.length; ++i) {
                let answer = question.answers[i];
                translation = getText(texts, question.questionId + '.' + answer.answerId, language);
                if (translation && translation.text) {
                    if (translation.text.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
                        return true;
                }

                translation = getText(texts, question.questionId + '.' + answer.answerId + ".explanation", language);
                if (translation && translation.text) {
                    if (translation.text.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
                        return true;
                }

                if (answer.dataId && answer.dataId.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
                    return true;
                if (answer.explanation && answer.explanation.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
                    return true;
                if (isArrayValid(answer.addRequiredData) && answer.addRequiredData.find((e) => e.toLowerCase().indexOf(filter.toLowerCase()) >= 0))
                    return true;
            }

        }
        if (question.dataId && question.dataId.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
            return true;
        if (question.category && question.category.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
            return true;
        if (isArrayValid(question.andFlagConditions)) {
            for (let i = 0; i < question.andFlagConditions.length; ++i) {
                if (question.andFlagConditions[i].toLowerCase().indexOf(filter.toLowerCase()) >= 0)
                    return true;
            }
        }
        if (question.explanation && question.explanation.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
            return true;
        if (isArrayValid(question.addRequiredData) && question.addRequiredData.find((e) => e.toLowerCase().indexOf(filter.toLowerCase()) >= 0))
            return true;
    }
    return false;
}

class QuestionsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dependencies: JSON.parse(localStorage.getItem("QuestionsView.dependencies") || 'true'),
            orderMode: this.props.orderMode || JSON.parse(localStorage.getItem("QuestionsView.orderMode") || 'false'),
            showCategories: this.props.showCategories || JSON.parse(localStorage.getItem("QuestionsView.showCategories") || 'true'),
            showAnswers: this.props.showAnswers || JSON.parse(localStorage.getItem("QuestionsView.showAnswers") || 'false'),
            showBaseline: this.props.showBaseline || JSON.parse(localStorage.getItem("QuestionsView.showBaseline") || 'false'),
            expandAll: this.props.expandAll || JSON.parse(localStorage.getItem("QuestionsView.expandAll") || 'false'),
            tags: [],
            filter: "",
            questions: [],
            dialog: null,
            treeData: null,
            errorState: false,
            expanded: null,
            mode: props.appContext.state.mode,
            language: props.appContext.state.language, //'en-us',
            texts: {},
            plan: null,
            progress: null
        };
        console.log(`QuestionsView:`, this.props, this.state)
    }

    componentDidMount() {
        this.loadContent();
        this.token = PubSub.subscribe('STORE_UPDATE', this.loadContent.bind(this));
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }

    loadContent() {
        const { appContext: { state: { plan }, stores: { DataTypesStore } } } = this.props;
        const { dependencies } = this.state;

        const questions = (this.props.questions || DataTypesStore.getQuestions()).filter((e) => dependencies || (plan && e.planId === plan.planId));
        const texts = DataTypesStore.getTextHash();
        this.setState({ questions, texts, filtered: null }, this.onContentLoaded.bind(this));
    }

    onContentLoaded() {
        this.normalizeOrder();
        this.initializeTreeData();

        // make sure the questions have actually been loaded..
        if (this.state.questions.length > 0) {
            // automatically open the question by ID if provided..
            let parts = window.location.pathname.slice(1).split('/');
            if (parts.length > 1) {
                window.history.replaceState(null, '', window.location.href.substring(0, window.location.href.lastIndexOf('/')));
                this.onEditQuestionID(parts[1]);
            }
        }
    }

    showNodeJSON({ node }) {
        let { appContext } = this.props;
        this.setState({
            dialog: <JsonDialog
                appContext={appContext}
                dataType={node.question}
                onDone={() => {
                    this.setState({ dialog: null });
                }} />
        });
    }

    captureExpandedState() {
        let { treeData } = this.state;
        this.localExpanded = []
        walk({
            treeData,
            callback: (rowInfo) => {
                if (rowInfo.node.isQuestion) {
                    if (rowInfo.node.expanded) {
                        this.localExpanded.push(rowInfo.node.question.questionId)
                    }
                }
                if (rowInfo.node.isCategory) {
                    if (rowInfo.node.expanded) {
                        this.localExpanded.push(rowInfo.node.nodeId)
                    }
                }

            },
            getNodeKey: ({ treeIndex }) => treeIndex,
            ignoreCollapsed: true,
        });
    }

    normalizeOrder(forceNormalization = false) {
        const { questions } = this.state;

        const categories = questions.map((q) => ({ category: q.category, categoryOrder: q.categoryOrder || 0 })).filter((v, i, a) => a.findIndex((k) => k.category === v.category) === i);
        categories.sort((a, b) => {
            // sort firstly by category order..
            if (a.categoryOrder !== b.categoryOrder) {
                return a.categoryOrder - b.categoryOrder;
            }
            // then fallback to the original sort method, which was a case senstive sort..     
            return a.category < b.category ? -1 : a.category > b.category ? 1 : 0
        });
        //console.log("sorted categories:", categories );
        // normalize the category order in the questions based of
        let modified = [];
        questions.map((q, i) => {
            let touched = false;
            if (q.order === undefined || q.order < 0 || forceNormalization) {
                if (q.order !== i) {
                    q.order = i;
                    touched = true;
                }
            }
            if (q.categoryOrder === undefined || q.categoryOrder < 0 || forceNormalization) {
                const categoryOrder = categories.findIndex((c) => c.category === q.category);
                if (q.categoryOrder !== categoryOrder) {
                    q.categoryOrder = categoryOrder;
                    touched = true;
                }
            }
            if (touched) {
                modified.push(q);
            }
            return q;
        });

        if (forceNormalization && modified.length > 0) {
            console.log("Saving modified questions:", modified);
            this.setState({ progress: <CircularProgress size={20} /> });
            this.saveQuestions(modified).then(() => {
                this.loadContent()
            }).catch((err) => {
                this.setState({ progress: null, error: getErrorMessage(err) });
            })
        }

        console.log("normalizeOrder:", forceNormalization, categories, questions);
    }

    initializeTreeData() {
        let { questions, language, texts, filter, expandAll,
            showBaseline, showCategories, showAnswers } = this.state;

        this.captureExpandedState();

        let treeData = [];
        let categoryNodes = {};
        if (!language)
            language = 'en-us';
        if (language === 'en-US')
            language = 'en-us';

        questions.sort((a, b) => a.order - b.order);
        for (let i = 0; i < questions.length; i++) {
            let question = questions[i];
            if (question.baseline === undefined) question.baseline = false;
            if (showBaseline !== question.baseline) {
                continue;
            }
            if (!filterQuestion(filter, question, texts, language)) {
                continue;
            }

            let text = isArrayValid(question.question) ? question.question[0].text : '';
            let translation = getText(texts, question.questionId, language);
            if (translation && translation.text)
                text = translation.text;
            text = text.replace(/<\/?[^>]+(>|$)/g, "");     // strip out any HTML from the text

            let expand = (this.localExpanded.includes(question.questionId))
            let subtitle = <span>{question.planId && <Plan appContext={this.props.appContext} planId={question.planId} />}
                {question.preConditions ? `, CONDITION` : null}
                {question.required ? ', REQUIRED' : null}
                {question.multiSelect ? ', MULTI-SELECT' : null}
                {question.eod ? ', EOD' : null}
                {question.detect ? ', DETECT' : null}
                {question.bail ? ', BAIL' : null}
                {question.dataId ? `, DATA: ${question.dataId}` : null}
                {question.baselineId ? `, BASELINE: ${question.baselineId}` : null}
                {isArrayValid(question.andFlagConditions) ? `, andFlags: ${question.andFlagConditions.join(',')}` : null}
                {isArrayValid(question.orFlagConditions) ? `, orFlags: ${question.orFlagConditions.join(',')}` : null}
                {isArrayValid(question.addFlags) ? `, addFlags: ${question.addFlags.join(',')}` : null}
                {isArrayValid(question.removeFlags) ? `, removeFlags: ${question.removeFlags.join(',')}` : null}
                {isArrayValid(question.bounds) ? ', Bounds' : null}
                {isArrayValid(question.mapping) ? ', Mapping' : null}
            </span>;

            let node = {
                isQuestion: true,
                question: question,
                expanded: (expandAll ? true : expand),
                isBaseline: question.baseline,
                text,
                subtitle,
                children: []
            };

            if (showAnswers === true) {
                let answers = question.answers;
                for (let j = 0; j < answers.length; j++) {
                    let answer = answers[j];
                    answer.order = j;

                    let category = answer.category
                    if (category) {
                        let translation = getText(texts, `${question.questionId}.${answer.answerId}.category`, language);
                        if (translation)
                            category = translation.text;
                    }
                    let text = answer.text[0];
                    let translation = getText(texts, `${question.questionId}.${answer.answerId}`, language);
                    if (translation)
                        text = translation.text;
                    text = text.replace(/<\/?[^>]+(>|$)/g, "");     // strip out any HTML from the text

                    if (category)
                        text = <span><b>{category + ' / '}</b>{text}</span>;

                    let subtitle = <span>
                        TYPE: {answer.controlType}
                        {answer.preConditions ? `, CONDITION` : null}
                        {answer.detect ? ', DETECT' : null}
                        {answer.bail ? ', BAIL' : null}
                        {answer.dataId ? `, DATA: ${answer.dataId}` : null}
                        {answer.baselineId ? `, BASELINE: ${answer.baselineId}` : null}
                        {isArrayValid(answer.addModels) ? `, addModels: ${answer.addModels.join(',')}` : null}
                        {isArrayValid(answer.addRequiredData) ? `, addRequiredData: ${answer.addRequiredData.join(',')}` : null}
                        {isArrayValid(answer.addOptionalData) ? `, addOptionalData: ${answer.addOptionalData.join(',')}` : null}
                        {isArrayValid(answer.andFlagConditions) ? `, andFlags: ${answer.andFlagConditions.join(',')}` : null}
                        {isArrayValid(answer.orFlagConditions) ? `, orFlags: ${answer.orFlagConditions.join(',')}` : null}
                        {isArrayValid(answer.addFlags) ? `, addFlags: ${answer.addFlags.join(',')}` : null}
                        {isArrayValid(answer.removeFlags) ? `, removeFlags: ${answer.removeFlags.join(',')}` : null}
                        {isArrayValid(answer.bounds) ? ', Bounds' : null}
                        {isArrayValid(answer.mapping) ? ', Mapping' : null}
                    </span>;

                    let child = {
                        isAnswer: true,
                        isQuestion: false,
                        question,
                        answer,
                        text,
                        subtitle
                    };
                    node.children.push(child);
                }
            }

            if (showCategories) {
                if (question.category === undefined) {
                    question.category = ''
                }
                if (!categoryNodes[question.category]) {
                    let nodeId = question.category.toLowerCase()
                    let expand = (this.localExpanded.includes(nodeId))
                    categoryNodes[question.category] = {
                        text: question.category || "Uncategorized",
                        categoryOrder: question.categoryOrder,
                        nodeId,
                        isCategory: true,
                        children: [],
                        expanded: expand || expandAll
                    };

                    treeData.push(categoryNodes[question.category]);
                    treeData.sort((a, b) => a.categoryOrder - b.categoryOrder);
                }
                categoryNodes[question.category].children.push(node);
            } else {
                treeData.push(node);
            }
        }
        this.setState({ treeData });
    }


    expandTree() {
        let self = this;
        let { treeData, expandAll } = self.state;
        const newTreeData = toggleExpandedForAll({
            treeData,
            expanded: expandAll
        });
        this.setState({
            treeData: newTreeData
        })
    }

    createNewQuestion() {
        let self = this;
        const { language, texts } = this.state;
        const { appContext } = this.props;
        this.setState({
            dialog: <EditQuestionDialog
                texts={texts}
                language={language}
                appContext={appContext}
                onCancel={() => {
                    self.setState({ dialog: null });
                }}
                onDone={() => {
                    self.setState({ dialog: null }, self.loadContent.bind(self));;
                }} />
        });
    }


    onEditQuestionID(questionId) {
        const { appContext, previewMode } = this.props;
        const { texts, language } = this.state;
        this.setState({
            dialog: <EditQuestionDialog
                style={{ width: '100%' }}
                questionId={questionId}
                texts={texts}
                language={language}
                appContext={appContext}
                previewMode={previewMode}
                onCancel={() => {
                    this.setState({ dialog: null });
                }}
                onDone={() => {
                    this.setState({ dialog: null }, this.loadContent.bind(this));
                }} />
        });
    }

    onEditQuestion(question) {
        const { appContext, previewMode } = this.props;
        const { texts, language } = this.state;
        this.setState({
            dialog: <EditQuestionDialog
                style={{ width: '100%' }}
                question={question}
                texts={texts}
                language={language}
                appContext={appContext}
                previewMode={previewMode}
                onCancel={() => {
                    this.setState({ dialog: null });
                }}
                onDone={() => {
                    this.setState({ dialog: null }, this.loadContent.bind(this));
                }} />
        });

    }

    canDrop(args) {
        console.log("canDrop:", args);
        const { node, nextParent, prevParent } = args;
        const { showCategories, orderMode } = this.state;
        //const { appContext: { state: { plan: { planId }}}} = this.props;

        if (!orderMode) return false;

        if (node.isCategory) {
            if (args.nextParent !== null) return false;       // categories can only be dropped on the root
            return true
        }
        //While grouping by category
        if (showCategories) {
            // question can move to other categories or order within category
            if (node.isQuestion && nextParent && nextParent.isCategory && (nextParent.nodeId !== prevParent.nodeId || orderMode)) {
                return true
            }
        } else {
            //change order of questions
            if (node.isQuestion && nextParent === null && orderMode) {
                return true
            }
        }

        return false
    };

    getBaselineQuestions(questions) {
        let baseline = [];
        for (let index = 0; index < questions.length; index++) {
            if (questions[index].baseline)
                baseline.push(questions[index]);
        }
        return baseline;
    }

    onChangeTree(treeData) {
        console.log("onChangeTree:", treeData);

        const { orderMode } = this.state;
        //const { appContext: { state: { plan: { planId }}}} = this.props;

        let nodes = [...treeData];
        let modified = [];
        let category = '';
        let minOrder = -1;
        let minCategoryOrder = -1;
        let categoryNode = null;

        while (nodes.length > 0) {
            let node = nodes.splice(0, 1)[0];
            if (node.isCategory) {
                categoryNode = node;
                let categoryOrder = node.categoryOrder;
                if (categoryOrder > minCategoryOrder) {
                    minCategoryOrder = categoryOrder + 1;
                } else if (categoryOrder < minCategoryOrder) {
                    categoryOrder = minCategoryOrder;
                    minCategoryOrder++;
                } else if (categoryOrder === minCategoryOrder) {
                    minCategoryOrder++;
                }

                if (orderMode && node.categoryOrder !== categoryOrder) {
                    console.log(`Category ${node.text} order changed from ${node.categoryOrder} to ${categoryOrder}`);
                    node.categoryOrder = categoryOrder;
                }

                category = node.text;
                nodes.splice(0, 0, ...node.children);
            }
            else if (node.isQuestion) {
                const question = node.question;
                let order = question.order;
                if (order > minOrder) {
                    minOrder = order + 1;
                } else if (order < minOrder) {
                    order = minOrder;
                    minOrder += 1;
                } else if (order === minOrder) {
                    minOrder++;
                }
                let touched = false;
                if (orderMode && categoryNode && question.categoryOrder !== categoryNode.categoryOrder) {
                    console.log(`Question ${question.questionId} category order modified, previous order: ${question.categoryOrder}, new order: ${categoryNode.categoryOrder}`);
                    question.categoryOrder = categoryNode.categoryOrder;
                    touched = true;
                }
                if (orderMode && question.order !== order) {
                    console.log(`Question ${question.questionId} order modified, previous order: ${question.order}, new order: ${order}`);
                    question.order = order;
                    touched = true;
                }
                if (category && question.category !== category) {
                    console.log(`Question ${question.questionId} category modified, previous category: ${question.category}, new category: ${category}`);
                    question.category = category;
                    touched = true;
                }

                if (touched && !modified.find((e) => e.questionId === question.questionId)) {
                    modified.push(question);
                }
                order += 1;
            }
        }

        if (modified.length > 0) {
            console.log("Saving modified questions:", modified);
            this.setState({ treeData, progress: <CircularProgress size={20} /> });
            this.saveQuestions(modified).then(() => {
                this.loadContent()
            }).catch((err) => {
                this.setState({ progress: null, error: getErrorMessage(err) });
            })
        }
        else {
            this.setState({ treeData });
        }
    }

    saveQuestions(modified) {
        if (modified.length > 0) {
            const { appContext: { stores: { DataTypesStore } } } = this.props;
            const grouped = modified.reduce((p, c) => {
                if (p[c.planId] === undefined) {
                    p[c.planId] = [c];
                } else {
                    p[c.planId].push(c);
                }
                return p;
            }, {});

            // use a map, so we can save each question into their original plan if we modify it via drag/drop.. 
            return Promise.all(Object.keys(grouped).map((planId) => DataTypesStore.saveQuestions(grouped[planId], planId)))
        } else {
            return Promise.resolve();
        }
    }

    cancel() {
        this.setState({ dialog: null });
    }

    deleteQuestion(question) {
        const { appContext } = this.props;
        const { texts, language } = this.state;

        if (this.props.questions && this.props.previewMode) {
            const remove = this.props.questions.indexOf(question);
            if (remove >= 0) {
                this.props.questions.splice(remove, 1);
                if (typeof this.props.onQuestions === 'function') {
                    this.props.onQuestions(this.props.questions);
                }
            }

            return this.loadContent();
        }
        this.setState({
            dialog:
                <DeleteQuestionDialog
                    question={question}
                    appContext={appContext}
                    language={language}
                    texts={texts}
                    onCancel={() => {
                        this.setState({ dialog: null });
                    }}
                    onDone={() => {
                        this.setState({ dialog: null }, this.loadContent.bind(this));
                    }}
                />
        });
    }

    clearErrors() {
        const self = this;
        self.setState({
            dialog:
                <Dialog
                    maxWidth={'sm'}
                    fullWidth={true}
                    model="false"
                    open={true}
                >
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to clear all <b>Question Errors</b>?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" self={self} style={styles.button} onClick={(e) => { self.cancel(); self.clearErrorsConfirmed() }}>Delete Errors</Button>
                        <Button variant="contained" self={self} style={styles.button} onClick={(e) => { self.cancel() }}>Cancel</Button>
                    </DialogActions>
                </Dialog>
        });
    }

    clearErrorsConfirmed() {
        const self = this;
        this.setState({ progress: <CircularProgress size={20} /> });
        deleteQuestionErrors(this.props.appContext, '*').then(() => {
            this.setState({ progress: null, errors: [] }, this.loadContent.bind(this));
        }).catch((err) => {
            console.error(err);
            self.setState({ progress: null, error: err.message });
        })
    }

    // displayErrors(question) {
    //     console.log("displayErrors:", question);
    //     const self = this;
    //     this.setState({
    //         dialog: <QuestionErrorsView
    //             appContext={this.props.appContext}
    //             questionId={question.questionId}
    //             onClose={() => { self.setState({ dialog: null }) }}
    //         />
    //     });
    // }

    nodeHasErrors(node) {
        const { appContext, previewMode } = this.props;
        if (previewMode) return false;

        const question_errs = appContext.stores.DataTypesStore.getErrors('questions').errors;
        if (node.isCategory) {
            for (let i = 0; i < node.children.length; ++i) {
                if (this.nodeHasErrors(node.children[i])) return true;
            }
        }
        else if (node.isQuestion) {
            if (!this.ensureTranslation(node)) {
                console.error("ensureTranslation is false for node:", node);
                return true;
            }
            if (!this.ensureQuestionAnswerTranslations(node)) {
                console.error("ensureQuestionAnswerTranslations is false for node:", node);
                return true;
            }
            if (question_errs[node.question.questionId]) {
                console.error("question_errs:", question_errs[node.question.questionId])
                return true;
            }
        } else if (node.isAnswer) {
            if (!this.ensureTranslation(node)) {
                console.error("ensureTranslation is false for node:", node);
                return true;
            }
        }

        return false;
    }

    getNodeProps({ node, path, treeIndex }) {
        const hasErrors = this.nodeHasErrors(node);
        const style = hasErrors ? { ...styles.node, boxShadow: `2px 2px 2px 2px #ff6600` } : styles.node;
        if (this.props.nodeWidth) {
            style.width = this.props.nodeWidth;
        }
        return {
            listIndex: 0,
            lowerSiblingCounts: [],
            style,
            title: (
                <div style={{ fontSize: 16, width: style.width, border: 0, overflow: 'hidden', fontWeight: 'normal' }}>{node.text}</div>
            ),
            buttons: (this.getNodeButtons(node, path, treeIndex))
        };
    }

    getNodeButtons(node, path, treeIndex) {
        const { language } = this.state;
        let buttons = [];

        if (node.isCategory) {
            buttons.push(<span key='order' style={{ fontSize: '12px' }}>{node.categoryOrder}</span>);
        }
        else if (node.isQuestion) {
            //const question_errs = this.props.appContext.stores.DataTypesStore.getErrors('questions').errors;

            buttons.push(<span key='order' style={{ fontSize: '12px' }}>{node.question.order}</span>);
            if (isArrayValid(node.question.addFlags)) {
                buttons.push(<FlagIcon key='flags' />);
            }

            if (language !== 'en-us') {
                buttons.push(<Tooltip title='Translate'><IconButton key='translate' onClick={this.onTranslateNode.bind(this, node)}><TranslateIcon /></IconButton></Tooltip>);
            }

            buttons.push(<Tooltip title='Edit'><IconButton key='edit' onClick={() => this.onEditQuestion(node.question)}><CreateIcon /></IconButton></Tooltip>);
            buttons.push(<Tooltip title='Delete'><IconButton key='delete' disabled={node.question.planId !== this.props.appContext.state.plan.planId}
                onClick={() => { this.deleteQuestion(node.question) }}><DeleteIcon /></IconButton></Tooltip>);

            buttons.push(<Tooltip title='Show Code'><IconButton key='code' onClick={() => this.showNodeJSON({ node, path, treeIndex })}><CodeIcon /></IconButton></Tooltip>);
            //let errors = question_errs[node.question.questionId];
            // if (node.question.errors > 0 || errors)
            //     buttons.push(<Tooltip key='errors' title={errors ? errors.join(', ') : ''}><IconButton onClick={(e) => { this.displayErrors(node.question) }}><ErrorIcon color="error" /></IconButton></Tooltip>);
        }
        else if (node.isAnswer) {
            let score = node.answer.score;
            let scoreLabel = <FormLabel style={{
                fontSize: 10, display: 'inline-block', color: 'purple', width: 50,
                textAlign: 'right', marginRight: 30, border: 'none'
            }}>
                {score}
            </FormLabel>;
            buttons.push(scoreLabel);

            if (language !== 'en-us') {
                buttons.push(<Tooltip title='Translate'><IconButton key='translate' onClick={this.onTranslateNode.bind(this, node)}><TranslateIcon /></IconButton></Tooltip>);
            }
            if (isArrayValid(node.answer.addFlags)) {
                buttons.push(<FlagIcon />);
            }
        }

        return buttons;
    }

    createTextExport() {
        let { questions, texts, language, filter, showBaseline } = this.state;
        let report = [];
        if (isArrayValid(questions)) {
            questions.sort((a, b) => {
                if (a.questionId < b.questionId)
                    return -1;
                else if (a.questionId > b.questionId)
                    return 1;
                return 0;
            });


            for (let index = 0; index < questions.length; index++) {
                let question = questions[index];
                if (question.baseline !== showBaseline) continue;

                if (!filterQuestion(filter, question)) {
                    continue;
                }
                let textId = question.questionId;
                let text = getText(texts, textId, language);

                let translation = '';
                if (text)
                    translation = text.text;

                // let english = question.question[0];
                let english = getText(texts, question.questionId, 'en-us');
                report.push({ item: report.length, textId, category: 'question', language, english: english.text, text: translation });

                let answers = question.answers;
                if (isArrayValid(answers)) {
                    for (let index = 0; index < answers.length; index++) {
                        let answer = answers[index];
                        textId = question.questionId + '.' + answer.answerId;
                        text = getText(texts, textId, language);
                        translation = '';
                        if (text)
                            translation = text.text;
                        let english = getText(texts, question.questionId + '.' + answer.answerId, 'en-us');
                        report.push({ item: report.length, textId, category: 'answer', language, english: english.text, text: translation });
                    }
                }
            }

        }

        // console.log(`text export report`, report);
        return report;
    }

    ensureQuestionAnswerTranslations(node) {
        let { texts, language } = this.state;
        if (!language)
            language = 'en-us';
        if (language === 'en-US')
            language = 'en-us';
        let allTextValid = true
        if (node.question && node.question.answers) {
            if (isArrayValid(node.question.answers)) {
                node.question.answers.forEach((answer) => {
                    const textId = node.question.questionId + '.' + answer.answerId
                    const text = getText(texts, textId, language)
                    if (!text || text.text === '') {
                        allTextValid = false
                    }
                })
            }
        }
        return allTextValid
    }

    onTranslateNode(node) {
        const self = this;
        let { texts, language } = this.state;
        let dialog =
            <AdHocTranslationDialog
                node={node}
                texts={texts}
                language={language}
                appContext={self.props.appContext}
                onCancel={() => {
                    self.setState({ dialog: null })
                }}
                onDone={() => {
                    self.setState({ dialog: null })
                    self.loadContent()
                }}
            />
        self.setState({ dialog: dialog })
    }

    ensureTranslation(node) {
        let { texts, language } = this.state;
        let textId = node.isQuestion ? node.question.questionId : node.question.questionId + '.' + node.answer.answerId;
        let text = getText(texts, textId, language);
        return (text && text.text)
    }

    testConversation() {
        const { appContext } = this.props;
        if (appContext.state.plan) {
            const dialog = <Drawer variant="persistent" anchor="right" open={true} >
                <ConversationTestView appContext={appContext} planId={appContext.state.plan.planId} onClose={this.cancel.bind(this)} />
            </Drawer>;
            this.setState({ progress: null, dialog: dialog });
        }
    }

    saveAll() {
        const { appContext } = this.props;
        const { questions } = this.state;
        const dialog = <SaveAllQuestionsDialog appContext={appContext} questions={questions} onDone={() => this.setState({ dialog: null })} onCancel={() => this.setState({ dialog: null })} />;
        this.setState({ progress: null, dialog: dialog });
    }

    render() {
        try {
            const { appContext, appContext: { state: { plan, plan: { planId } } } } = this.props;
            const { error, filter, dialog } = this.state;
            const { expandAll, showBaseline, showCategories, showAnswers, language, dependencies, orderMode, questions } = this.state;
            const store = appContext.stores.DataTypesStore;

            const sortableTree = this.state.treeData ?
                <div style={{ height: this.props.treeHeight || (window.innerHeight - 250), width: '100%' }} valign='top'>
                    <SortableTree
                        treeData={this.state.treeData}
                        maxDepth={maxDepth}
                        canDrop={this.canDrop.bind(this)}
                        onChange={this.onChangeTree.bind(this)}
                        theme={FileExplorerTheme}
                        canNodeHaveChildren={node => !node.isAnswer}
                        isVirtualized={true}
                        generateNodeProps={this.getNodeProps.bind(this)}
                    />
                </div> : null;

            if (this.props.previewMode) {
                return <>
                    {sortableTree}
                    {dialog}
                </>
            }
            const importExport = <ImportExport
                asText={true}
                name={`QuestionContent_${language} `}
                exportStart={() => {
                    return Promise.resolve(this.createTextExport());
                }}
                exportRow={(row) => {
                }}
                importStart={() => {
                    return Promise.resolve();
                }}
                importRow={(row) => {
                    // return self.importText(row);
                }}
                importDone={(err) => {
                }}
            />;


            const languages = require('../data/Languages.json');

            return (
                <table width="100%"><tbody>
                    <tr>
                        <td>
                            <TextField style={{ margin: 5, width: 500 }} value={filter} label="Filter"
                                onChange={(event) => {
                                    this.setState({ filter: event.target.value }, this.initializeTreeData.bind(this))
                                }} />
                            <SelectLanguage appContext={appContext} language={language} languages={languages} onChange={(newLanguage) => {
                                this.setState({ language: newLanguage }, this.initializeTreeData.bind(this));
                            }} />
                        </td>
                        <td width="400" align="right" >
                            {error}
                            <Tooltip title='Allow question order to be changed by drag and drop'>
                                <FormControlLabel label='Order Mode' control={<Switch checked={orderMode} onChange={(e) => {
                                    this.setState({ orderMode: e.target.checked });
                                }} />} />
                            </Tooltip>
                            <Tooltip title='Normalize Order'><IconButton onClick={() => this.normalizeOrder(true)}><NormalizeIcon /></IconButton></Tooltip>
                            <EditableNote appContext={appContext} textId={`questionsTooling`} planId={planId} />
                            <Tooltip title='Refresh'><IconButton disabled={store.progress !== null} onClick={store.loadDataTypes.bind(store)}>{store.progress || <RefreshIcon title="Reresh" />}</IconButton></Tooltip>
                            <Tooltip title='Test Questions'><IconButton onClick={this.testConversation.bind(this)}><TestIcon title="Test Conversation" /></IconButton></Tooltip>
                            <Tooltip title='Create New Question'><IconButton onClick={this.createNewQuestion.bind(this)}><AddIcon /></IconButton></Tooltip>
                            <Tooltip title="Save All"><IconButton disabled={plan && plan.protected} onClick={this.saveAll.bind(this)}><SaveIcon /></IconButton></Tooltip>
                        </td>
                        <td width="50" />
                    </tr>
                    <tr>
                        <td >
                            <FormControlLabel control={<Checkbox checked={expandAll} onChange={(e) => {
                                this.setState({ expandAll: e.target.checked }, this.expandTree.bind(this));
                                localStorage.setItem("QuestionsView.expandAll", `${e.target.checked}`);
                            }} />} label="Expand/Collapse All" />
                            <FormControlLabel control={<Checkbox
                                checked={showBaseline} onChange={(e) => {
                                    this.setState({ showBaseline: e.target.checked },
                                        this.initializeTreeData.bind(this));
                                    localStorage.setItem("QuestionsView.showBaseline", `${e.target.checked}`);
                                }} />} label="Baseline" />
                            <FormControlLabel control={<Checkbox
                                checked={showCategories} onChange={(e) => {
                                    this.setState({ showCategories: e.target.checked }, this.initializeTreeData.bind(this));
                                    localStorage.setItem("QuestionsView.showCategories", `${e.target.checked}`);
                                }} />} label="Show Categories" />
                            <FormControlLabel control={<Checkbox
                                checked={showAnswers} onChange={(e) => {
                                    this.setState({ showAnswers: e.target.checked }, this.initializeTreeData.bind(this));
                                    localStorage.setItem("QuestionsView.showAnswers", `${e.target.checked}`);
                                }} />} label="Show Answers" />
                            <FormControlLabel control={<Checkbox
                                checked={dependencies} onChange={(e) => {
                                    this.setState({ dependencies: e.target.checked }, this.loadContent.bind(this));
                                    localStorage.setItem("QuestionsView.dependencies", `${e.target.checked}`);
                                }} />} label="Show Dependencies" />
                        </td>
                        <td align="right" style={{ marginRight: 150 }}>
                            Total Questions: {questions && questions.length}
                        </td>
                        <td width="50" />
                    </tr>
                    <tr>
                        <td colSpan="3">
                            {sortableTree}
                            {dialog}
                        </td>
                    </tr>
                    <tr>
                        <td>
                        </td>
                        <td align="right">
                            <div style={styles.footerTools}>
                                {importExport}
                                <Tooltip title="Delete Errors" >
                                    <IconButton aria-label="" onClick={() => { this.clearErrors() }}>
                                        <DeleteSweepIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody></table>
            );
        } catch(err) {
            console.error("QuestionsView.render error:", err, this );
            return null;
        }
    }
}



const styles = {
    div: {
        margin: 10
    },
    footerTools: {
        display: 'flex'
    },
    progress: {
        color: 'red'
    },
    formControl: {
        margin: '1px',
        minWidth: 120,
    },
    sidebarHeader: {
        display: 'flex',
        padding: '0 8px',
        justifyContent: 'left'
    },
    node: {
        height: 50,
        width: 1050,
        border: 0,
        cursor: 'pointer'
    }
};


QuestionsView.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object.isRequired
};


export default withStyles(styles)(QuestionsView);
